import React, { useState, useEffect, useRef } from 'react';
import './BuscarProductoModal.css';
import Mensaje from '../../../../Mensaje';
import PuenteApi from '../../../../pageauth/PuenteApi';



const BuscarProductoModal = ({ isVisible, onClose, onSelectProduct }) => {
    const { SetMensaje } = Mensaje();
    const {ObtenerProductos} = PuenteApi();

    // Mueve useState dentro del componente
    const [productosLista, setProductosLista] = useState([
        { codigo: '0', descripcion: 'Cargando productos...', venta: 0.00 }
    ]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterType, setFilterType] = useState('DESCRIPCION'); 
    const [filteredProducts, setFilteredProducts] = useState(productosLista);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const searchInputRef = useRef(null);
    const rowsContainerRef = useRef(null);

    useEffect(() => {
        if (isVisible && filteredProducts.length > 0 && rowsContainerRef.current) {
            // Obtenemos todas las filas
            const rows = rowsContainerRef.current.querySelectorAll('.fila-producto');
            
            // Verificamos que el índice esté dentro del rango
            if (selectedIndex >= 0 && selectedIndex < rows.length) {
                const selectedRow = rows[selectedIndex];
                
                // Usamos scrollIntoView para desplazar el contenedor al elemento seleccionado
                selectedRow.scrollIntoView({
                    behavior: 'smooth', // Desplazamiento suave
                    block: 'nearest',   // Asegura que esté visible sin importar la posición
                });
            }
        }
    }, [selectedIndex, isVisible, filteredProducts]);

    const obtenerProductos = async () => {
        try {
            const response = await ObtenerProductos();
            if (response && Array.isArray(response) && response.length > 0) {
                const productos = response.map((producto) => ({
                    codigo: producto.sku, 
                    descripcion: producto.descripcion, 
                    venta: parseFloat(producto.precio) || 0.00, // Asegúrate de que el precio sea un número
                    iva: producto.iva
                }));
                setProductosLista(productos);
                setFilteredProducts(productos);
            } else {
                SetMensaje("Error", "No se encontraron productos", 3000);
                setProductosLista([{ codigo: '0', descripcion: 'Error al cargar productos', venta: 0.00 }]);
                setFilteredProducts([{ codigo: '0', descripcion: 'Error al cargar productos', venta: 0.00 }]);
            }
        } catch (error) {
            SetMensaje("Error", "Hubo un problema con la solicitud", 3000);
        }
    };

    // Usamos useEffect para obtener los productos al montar el componente
    useEffect(() => {
            if(isVisible){
                setSearchTerm('');
                obtenerProductos();
            }
    }, [isVisible]); // Dependencias vacías para que solo se ejecute al montar el componente

    useEffect(() => {
        const lowerCaseSearch = searchTerm.toLowerCase();
        
        const results = productosLista.filter(p => {
            if (filterType === 'DESCRIPCION') {
                return p.descripcion.toLowerCase().includes(lowerCaseSearch);
            } else if (filterType === 'CODIGO') {
                return p.codigo.includes(searchTerm); 
            }
            return false;
        });

        setFilteredProducts(results);
        setSelectedIndex(0);
    }, [searchTerm, filterType]);

    useEffect(() => {
        if (isVisible && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [isVisible]);

    const handleSelect = (product) => {
        const productoParaFactura = {
            codigo: product.codigo,
            descripcion: product.descripcion,
            cantidad: "1", 
            precio: product.venta.toFixed(2), 
            iva: product.iva,
        };
        onSelectProduct(productoParaFactura);
        onClose();
    };

    const handleConfirm = () => {
        if (filteredProducts.length > 0) {
            handleSelect(filteredProducts[selectedIndex]);
        }
    };
    
    const handleKeyDown = (event) => {
        event.stopPropagation(); 
        if (event.key === 'Escape') {
            onClose();
            return;
        }

        if (filteredProducts.length === 0) return;

        if (event.key === 'ArrowDown') {
            event.preventDefault();
            setSelectedIndex(prev => Math.min(prev + 1, filteredProducts.length - 1));
        } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            setSelectedIndex(prev => Math.max(prev - 1, 0));
        } else if (event.key === 'Enter') {
            event.preventDefault(); 
            handleConfirm(); // Confirmar con Enter
        }
    };


    useEffect(() => {
        if (isVisible) {
            window.addEventListener('keydown', handleKeyDown);
            return () => window.removeEventListener('keydown', handleKeyDown);
        }
    }, [isVisible, filteredProducts, selectedIndex, filterType]); 


    if (!isVisible) return null;

    return (
        <div className="modal-overlay-producto">
            <div className="modal-content-producto">
                
                <div className="modal-header-producto">
                    <div className="buscador-producto-filtro">
                        <label>FILTRAR POR</label>
                        <select 
                            className="select-filtro" 
                            value={filterType}
                            onChange={(e) => setFilterType(e.target.value)}
                        >
                            <option>DESCRIPCION</option>
                            <option>CODIGO</option>
                        </select>
                    </div>
                    
                    <div className="buscador-producto-input">
                        <input
                            ref={searchInputRef}
                            type="text"
                            placeholder={`Buscar por ${filterType}...`}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>
                
                {/* TABLA DE PRODUCTOS */}
                <div className="tabla-producto">
                    <div className="encabezado-tabla-producto">
                        <div>CÓDIGO</div>
                        <div>DESCRIPCION</div>
                        <div>VENTA</div>
                    </div>

                    <div className="filas-producto" ref={rowsContainerRef}>
                        {filteredProducts.map((p, i) => (
                            <div
                                key={p.codigo}
                                className={`fila-producto ${i === selectedIndex ? 'seleccionado' : ''}`}
                                onDoubleClick={() => handleSelect(p)}
                                onClick={() => setSelectedIndex(i)}
                            >
                                <div>{p.codigo}</div>
                                <div>{p.descripcion}</div>
                                <div>{`$ ${p.venta.toFixed(2).replace('.', ',')}`}</div>
                            </div>
                        ))}
                        
                        {filteredProducts.length === 0 && (
                            <div className="fila-producto-vacia">No se encontraron productos.</div>
                        )}
                    </div>
                </div>

                <div className="modal-footer-producto">
                    <div className="total-registros">
                        Total: {filteredProducts.length} registros disponibles
                    </div>
                    
                    {/* Botón de Cancelar */}
                    <button className="boton-cancelar-producto" onClick={onClose}>
                        ❌ Cancelar
                    </button>
                    
                    {/* Botón de Ok */}
                    <button className="boton-ok-producto" onClick={handleConfirm}>
                        ✅ Ok
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BuscarProductoModal;
